/**
 * @generated SignedSource<<ac6164b14fdc12e5a30f221f5da12bbc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AdminAssumeMutationsAllowByIdMutation$variables = {
  id: string;
};
export type AdminAssumeMutationsAllowByIdMutation$data = {
  readonly assumeProfileWithID: boolean;
};
export type AdminAssumeMutationsAllowByIdMutation = {
  response: AdminAssumeMutationsAllowByIdMutation$data;
  variables: AdminAssumeMutationsAllowByIdMutation$variables;
};

const node: ConcreteRequest = (function () {
  var v0 = [
      {
        defaultValue: null,
        kind: 'LocalArgument',
        name: 'id',
      },
    ],
    v1 = [
      {
        alias: null,
        args: [
          {
            kind: 'Variable',
            name: 'id',
            variableName: 'id',
          },
        ],
        kind: 'ScalarField',
        name: 'assumeProfileWithID',
        storageKey: null,
      },
    ];
  return {
    fragment: {
      argumentDefinitions: v0 /*: any*/,
      kind: 'Fragment',
      metadata: null,
      name: 'AdminAssumeMutationsAllowByIdMutation',
      selections: v1 /*: any*/,
      type: 'Mutation',
      abstractKey: null,
    },
    kind: 'Request',
    operation: {
      argumentDefinitions: v0 /*: any*/,
      kind: 'Operation',
      name: 'AdminAssumeMutationsAllowByIdMutation',
      selections: v1 /*: any*/,
    },
    params: {
      cacheID: '7b372b11d45d7a95bba6714e1bd8833f',
      id: null,
      metadata: {},
      name: 'AdminAssumeMutationsAllowByIdMutation',
      operationKind: 'mutation',
      text: 'mutation AdminAssumeMutationsAllowByIdMutation(\n  $id: ID!\n) {\n  assumeProfileWithID(id: $id)\n}\n',
    },
  };
})();

(node as any).hash = '606053265a9efb4b2227c81465e7d65b';

export default node;
